export enum Locale {
    Today = 'I dag',
    This_Month = 'Denne Måneden',
    Lifetime = 'Totalt',
    PowerToday = 'Energi fra våre solpaneler',
    EnergyDaily = 'Energi fra solpanel de siste dagene',
}
